@if (effectivenessModel && taskCounts) {
    <div class="eff-details-panel">
        <div class="h3-title">
            <span class="section">
                <span
                    [title]="'controls.effControlTaskCountInfoBox.testPlanName' | transloco"
                    data-uiid="new-eff-info-box-testplan-name"
                    class="info-label regular-text"
                    >{{ effectivenessModel.name }}
                </span>
                <span
                    [title]="'controls.effControlTaskCountInfoBox.startDate' | transloco"
                    data-uiid="new-eff-info-box-testplan-start-date"
                    class="info-label regular-text"
                    >{{ effectivenessModel.startDate | dateFormat }}</span
                >
                <span class="separator" class="info-label regular-text"> | </span>
                <span
                    [title]="'controls.effControlTaskCountInfoBox.endDate' | transloco"
                    data-uiid="new-eff-info-box-testplan-end-date"
                    class="info-label regular-text"
                    >{{ effectivenessModel.endDate | dateFormat }}</span
                >
                @if (periodOngoing) {
                    <span [title]="'controls.effControlTaskCountInfoBox.warningIcon' | transloco" class="warning-icon">
                        <eff-icon
                            [icon]="icon"
                            size="warning"
                            data-uiid="new-eff-info-box-warning-icon"
                        >
                        </eff-icon>
                    </span>
                    <span
                        [title]="'controls.effControlTaskCountInfoBox.warningText' | transloco"
                        data-uiid="new-eff-info-box-warning-text"
                        class="info-box-warning"
                    >
                        {{ 'controls.effControlTaskCountInfoBox.periodNotFinished' | transloco }}
                    </span>
                }
            </span>
        </div>
        <div class="rows-container">
            <div class="row-container count-gap">
                <div
                    class="regular-text semibold row-label"
                    data-uiid="new-eff-info-box-population-size-label"
                >
                    {{ 'controls.effControlTaskCountInfoBox.populationSize' | transloco }}
                </div>
                <div class="regular-text" data-uiid="new-eff-info-box-population-size">
                    {{ taskCounts.populationSize }}
                </div>
            </div>
            <div class="row-container count-gap">
                <div
                    class="regular-text semibold row-label"
                    data-uiid="new-eff-info-box-completed-label"
                >
                    {{ 'controls.effControlTaskCountInfoBox.completed' | transloco }}
                </div>
                <div class="regular-text" data-uiid="new-eff-info-box-completed">
                    {{ taskCounts.completed }}
                </div>
            </div>

            <div class="row-container count-gap">
                <div
                    class="regular-text semibold row-label"
                    data-uiid="new-eff-info-box-not-completed-label"
                >
                    {{ 'controls.effControlTaskCountInfoBox.notCompleted' | transloco }}
                </div>
                <div class="regular-text" data-uiid="new-eff-info-box-not-completed">
                    {{ taskCounts.notCompleted }}
                </div>
            </div>
        </div>
        @if (taskCounts.populationSize === 0) {
            <div
                class="regular-text no-executions-label"
                data-uiid="new-eff-info-box-no-tasks-found-label"
            >
                {{ 'controls.effControlTaskCountInfoBox.noControlExecutions' | transloco }}
            </div>
        }
    </div>
}
